import { DatesSetArg } from "@fullcalendar/core";
import { ENV } from "@utils/env";
import { useGetApartmentEditionMutation } from "@services/member/apartment/apartment.endpoints";
import { ApartmentEdition } from "@services/member/apartment/apartment.types";
import { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getJwtToken } from "@features/auth/auth.slice";
import { useSelector } from "react-redux";
import moment from "moment";

export const useBookingEditionPageVM = () => {
    const [editionData, setEditionData] = useState<ApartmentEdition>();
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();
    const jwt = useSelector(getJwtToken);

    const MySwal = withReactContent(Swal);

    const [
        getApartmentEdition,
        {
            isLoading: isGetApartmentEditionLoading,
            isSuccess: isGetApartmentEditionSuccess,
            data: getApartmentEditionResponse
        }
    ] = useGetApartmentEditionMutation();
   
    const handleDatesSet = useCallback((dateInfo: DatesSetArg) => {
        const startDate = dateInfo.start;
        const endDate = dateInfo.end;
        setStartDate(moment(startDate.toISOString().split('T')[0]).add(1, 'day').format('YYYY-MM-DD'));
        setEndDate(moment(endDate.toISOString().split('T')[0]).format('YYYY-MM-DD'));
        getApartmentEdition({ start: startDate.toISOString(), end: endDate.toISOString() });
    }, []);

    useEffect(() => {
        if (isGetApartmentEditionSuccess) {
            setEditionData(getApartmentEditionResponse.data);
        }
    }, [isGetApartmentEditionSuccess, getApartmentEditionResponse]);

    const openPrintBooking = () => {
        window.open(`${ENV.API_URL}/member/apartment/bookings/export?start=${startDate}&end=${endDate}&jwt=${jwt}`, '_blank');
    }


    return {
        handleDatesSet,
        editionData,
        MySwal,
        isLoading: isGetApartmentEditionLoading,
        openPrintBooking
    };
};
